export default __webpack_public_path__ + "static/media/sweet3.c3447ae8.jpg";